export class TakePayment {
    devicePaymentEnabled: boolean;
    cloverConnectorPayment: boolean;
    squareConnectorPayment: boolean;
    scanToPayPayment: boolean;
    cloverDeviceId: string;
    cloverDeviceSerial: string;
    squareDeviceId: string;
    deviceAlias: string;
    merchantId: string;
    paymentRequired: any;
    creditCardPayment: boolean;
    paymentMode: 'disabled' | 'required' | 'optional';
    preauthorize: boolean;
}

